import BlogsDetailsSection from "../components/blogsDetailsSection/BlogsDetailsSection";

function BlogsDetails() {
  return <BlogsDetailsSection />;
}

export default BlogsDetails;
